export default __webpack_public_path__ + "static/media/havas-logo.fc5cda46.png";